module.exports = __webpack_public_path__ + "img/50.9a5f2ab8.jpg";